import { List, Map } from "immutable";

import { SemanticCategory } from "@seneca/tags-service-consts";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import Tag from "../../models/Tag";
import { normalizeString } from "../utils";
import * as tag from "./tag";

type TagId = string;
type State = Map<TagId, Tag>;

export function getTag(tags: State, id: TagId) {
  return tags.get(id);
}

// @ts-ignore
export const getTagName: (arg0: State, arg1: TagId) => string = composeSelector(
  // @ts-ignore
  getTag,
  tag.getName
);

// @ts-ignore
export const getParentId: (arg0: State, arg1: TagId) => string =
  // @ts-ignore
  composeSelector(getTag, tag.getParentId);

export const getCategoryIds: (arg0: State, arg1: TagId) => List<string> =
  // @ts-ignore
  composeSelector(getTag, tag.getCategoryIds);

const emptyList: List<any> = List();

export function getRootTag(tags: State) {
  // @ts-ignore
  return tags.find((tag: any) => tag.details && tag.details.get("root"));
}

export function getRootCategoryIds(tags: State) {
  const rootTag = getRootTag(tags);
  // @ts-ignore
  return (rootTag && getCategoryIds(tags, rootTag.get("id"))) || emptyList;
}

export function getFirstRootCategoryId(tags: State) {
  return getRootCategoryIds(tags).get(0);
}

// @ts-ignore
export const showCardAdOnYourCoursesPage: (
  arg0: State,
  arg1: TagId
) => boolean | null | undefined = composeSelector(
  // @ts-ignore
  getTag,
  tag.showCardAdOnYourCoursesPage
);

// @ts-ignore
export const applyPremiumStyleToFilter: (
  arg0: State,
  arg1: TagId
) => boolean | null | undefined = composeSelector(
  // @ts-ignore
  getTag,
  tag.applyPremiumStyleToFilter
);

// @ts-ignore
export const isSectionPreviewEnabled: (
  arg0: State,
  arg1: TagId
) => boolean | null | undefined = composeSelector(
  // @ts-ignore
  getTag,
  tag.enableSectionPreview
);

export const showAssignmentSelfMarkedQuestions: (
  arg0: State,
  arg1: TagId
) => boolean = composeSelector(
  // @ts-ignore
  getTag,
  tag.showAssignmentSelfMarkedQuestions
);

export const getTagDescription: (
  arg0: State,
  arg1: TagId
  // @ts-ignore
) => string | null | undefined = composeSelector(getTag, tag.getDescription);

export const getTagSubjectGroup: (
  arg0: State,
  arg1: TagId
  // @ts-ignore
) => string | null | undefined = composeSelector(getTag, tag.getSubjectGroup);

// @ts-ignore
export const getTagCoursesFilterOnly: (
  arg0: State,
  arg1: TagId
) => boolean | null | undefined = composeSelector(
  // @ts-ignore
  getTag,
  tag.getTagCoursesFilterOnly
);

// @ts-ignore
export const isTagHidden: (
  arg0: State,
  arg1: TagId
  // @ts-ignore
) => boolean | null | undefined = composeSelector(getTag, tag.isHidden);

export const getVisibleTagIds = (
  tags: State,
  tagIds: List<string>
): List<string> => tagIds.filter(tagId => !isTagHidden(tags, tagId));

export const getTagDetails: (arg0: State, arg1: TagId) => Record<string, any> =
  // @ts-ignore
  composeSelector(getTag, tag.getDetails);

export const getSomeTagsByIds = (tags: State, tagIds: string[]): Array<Tag> =>
  // @ts-ignore
  tagIds.map((id: any) => getTag(tags, id));

export const findTagIdByName = (
  tags: State,
  tagName: string
): string | null | undefined => {
  const tagState = tags.find(
    tagState =>
      // @ts-ignore
      normalizeString(tag.getName(tagState)) === normalizeString(tagName) &&
      tag.getId(tagState)
  );
  return tagState && tag.getId(tagState);
};

// @ts-ignore
export const getSemanticCategory: (
  arg0: State,
  arg1: TagId
) => SemanticCategory = composeSelector(
  // @ts-ignore
  getTag,
  tag.getSemanticCategory
);
